// NotificationPreferences.js
import React from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../hooks/loader";
import "./notificationpreferences.scss";
import useNotificationPreferences from "../../hooks/notificationPref/useNotificationPreferences";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import VerifyEmail from "../VerifyEmail/VerifyEmail";
import { toast } from "react-toastify";
import { API_URL } from "../../utils/ApiUrl";
import CustomToast from '../../components/CustomToast';


const NotificationPreferences = () => {

    const [loading, setLoading] = useState(false);
    const [viaWebBool, setViaWebBool] = useState(false);
    const [viaEmailBool, setViaEmailBool] = useState(false);

    // console.log(preferences, togglePreference, savePreferences, "preferences, togglePreference, savePreferences");



    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show1, setShow1] = useState(false);

    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);


    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const { preferences, togglePreference, savePreferences } = useNotificationPreferences({ setLoading, setViaWebBool, setViaEmailBool, handleShow });
    // console.log(viaWebBool, viaEmailBool, "viaEmailBoolviaEmailBoolviaEmailBool");
    // localStorage?.getItem(isEmailVerified)
    // ============================================= Verify Email ======================================== //

    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [originalEmail, setOriginalEmail] = useState(""); // Store the original email
    const [email, setEmail] = useState(""); // Track the current email
    const [isEmailVerified, setIsEmailVerified] = useState(false); // Track verification status

    const handleEmailChange = (e) => {
        if (e || email == null || email == "" || email == undefined) {
            const newEmail = e.target.value;
            setEmail(newEmail);

            // If the entered email is the same as the original, keep it verified; otherwise, unverify it
            setIsEmailVerified(newEmail === originalEmail);
        } else {
            // toast?.error("Email is required!");
             CustomToast.show('error', 'Error!', 'Email is required!');

        }
    };

    // Step 1: Send OTP to Email
    const sendOtp = async () => {
        if (!email) {
            // toast?.error("Email is required!");
            CustomToast.show('error', 'Error!', 'Email is required!');
            return;
        }

        // Regular expression to validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            // toast?.error("Please enter a valid email address!");
            CustomToast.show('error', 'Error!', 'Please enter a valid email address!');
            return;
        }

        const accessToken = localStorage.getItem("accessToken");
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}users/send-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                handleClose();
                handleShow1();
                setLoading(false);

            } else {
                const errorData = await response.json();
                // toast.error(
                //     errorData?.message || "Failed to send OTP. Please try again.",
                //     {
                //         autoClose: 15000, // 15 seconds
                //     }
                // );
                CustomToast.show('error', 'Error!', errorData?.message || "Failed to send OTP. Please try again.");
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // toast.error("An error occurred. Please check your network connection.", {
            //     autoClose: 15000, // 15 seconds
            // });
            CustomToast.show('error', 'Error!', "An error occurred. Please check your network connection.");
        }
    };


    // Step 2: Verify OTP
    const verifyOtp = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const otpCode = otp.join(""); // Concatenate OTP array
        // console.log(otpCode?.length, 'otpCode?.length ');
        if (otpCode?.length < 6) {
            // toast.error("Invalid OTP code", {
            //     autoClose: 15000, // 15 seconds
            // });
            CustomToast.show('error', 'Error!', 'Invalid OTP code');
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}users/verify-otp`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({ otp: otpCode }),
            });

            if (response.ok) {
                // getProfile();
                console.log(response, "response in verify-otp ");

                console.log("verify-otp logggg");
                localStorage?.setItem("isEmailVerified", true);
                handleClose1();
                setLoading(false);

                // handleShow78();
                // handleClose77();
                handleShow2();
            } else {
                const errorMessage = await response.text(); // Optional: Extract error message from response
                // toast.error(`Failed to verify OTP. ${errorMessage || "Please try again."}`);
                // toast.error(`Failed to verify OTP.`);
                CustomToast.show('error', 'Error!', `Failed to verify OTP.`);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // toast.error(`Something went wrong. ${error.message}`, {
            //     autoClose: 15000, // 15 seconds
            // });
            CustomToast.show('error', 'Error!', `Something went wrong. ${error.message}`);
        
            console.error("Error verifying OTP:", error);
        }
    };

    // Handle OTP input change and focus
    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        if (value.match(/^[0-9]$/)) {
            // Ensure single digit
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (index < otp.length - 1)
                document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    // Handle OTP backspace and focus
    const handleOtpBackspace = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];

            if (otp[index] === "" && index > 0) {
                // Focus the previous input if the current one is empty
                document.getElementById(`otp-${index - 1}`).focus();
            } else {
                // Clear the current input
                newOtp[index] = "";
                setOtp(newOtp);
            }
        }
    };


    // ============================================= Verify Email ======================================== //


    return (
        <>
            {loading && <Loader />}
            <section className="mainpreferences">
                <img src="/assets/importantassets/backshade.png" alt="backshade" className="backshade" />
                <div className="boxpreference">
                    <div className="upperperference">
                        <p>Notification Preferences</p>
                        <button
                            className={`save ${!viaWebBool && !viaEmailBool ? 'disable' : ''}`}
                            disabled={!viaWebBool && !viaEmailBool}
                            onClick={() => {
                                const isEmailVerified = localStorage?.getItem("isEmailVerified");
                                console.log(isEmailVerified, "isEmailVerified", viaWebBool, "viaWebBool", viaEmailBool);

                                if (viaEmailBool) {
                                    if (isEmailVerified == "true") {
                                        savePreferences(navigate);
                                    } else {
                                        handleShow(); // Show modal if not verified
                                    }
                                } else if (viaWebBool) {
                                    savePreferences(navigate);
                                }
                            }}
                        >
                            Save
                        </button>
                    </div>
                    {["participateTasks", "createTasks", "tasksReported", "reportTask"].map(taskType => (
                        <div className="participatetask" key={taskType}>
                            <h2 className="upperheading">
                                {taskType === "participateTasks" &&( "When you participate in a task" 
                                )}
                                 {taskType === "createTasks" &&(
                                "When you create a task")}
                                  {taskType === "tasksReported" &&(
                                "When your task is reported")}
                                     {taskType === "reportTask" &&(
                                "When you report a task")}
                            </h2>
                            {preferences[taskType].map(task => (
                                <div className="newtask" key={task.id}>
                                    <div className="left">
                                        <p>{task.description}</p>
                                    </div>
                                    <div className="right">
                                        <div className="parentcheck">
                                            <div className="checkboxmain"
                                                onClick={() => {
                                                    // togglePreference(taskType, task.id, "viaWeb");
                                                    // setViaWebBool(!viaWebBool);
                                                    togglePreference(taskType, task.id, "viaWeb");
                                                }}
                                            >
                                                <p className="checkboxpara">Website</p>
                                                <label className="checkbox">
                                                    <img src={`/assets/notification/${task.viaWeb ? "checked" : "unchecked"}.svg`} alt="checkbox" />
                                                </label>
                                            </div>
                                            <div className="checkboxmain" onClick={() => {
                                                togglePreference(taskType, task.id, "viaEmail");
                                                setViaEmailBool(!viaEmailBool);
                                                // togglePreference(taskType, task.id, "viaEmail");
                                            }}
                                            >
                                                <p className="checkboxpara">Email</p>
                                                <label className="checkbox">
                                                    <img src={`/assets/notification/${task.viaEmail ? "checked" : "unchecked"}.svg`} alt="checkbox" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section >

            <Modal className="verifyemail" show={show} onHide={handleClose} centered>
                <Modal.Header className="modalhead" closeButton>
                    {/* <span className="forarrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <path d="M15.2993 8.49998H2.70101M2.70101 8.49998L8.10028 3.10071M2.70101 8.49998L8.10028 13.8993" stroke="#222D37" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                    </svg></span> */}
                    <Modal.Title> Verify Email Address</Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    <div className="maincontent">
                        <h3 className="mainhead">  Please verify your email to enable email notifications.</h3>
                        <p>Email Address</p>
                        <div className="parentinput">
                            <input type="text"
                                placeholder="johndoe@email.com"
                                value={email}
                                onChange={(e) => handleEmailChange(e)}
                                disabled={isEmailVerified}
                            />
                            {localStorage?.getItem("isEmailVerified") === "true" ? (
                                // <img src="/assets/verified.svg" className='' alt="" srcset="" />
                                <button
                                    style={{ maxWidth: "70px" }}
                                    className="verify bg-success text-light pe-3"
                                >
                                    Verified
                                </button>
                            ) : (
                                <button
                                    className="verify"
                                    onClick={() => {
                                        setOtp(["", "", "", "", "", ""]);
                                        sendOtp();
                                    }}
                                >
                                    Verify
                                </button>
                            )}
                        </div>
                        <div className="endbtns">
                            <button className="cancle" onClick={() => handleClose()}>Cancel</button>
                            {
                                localStorage?.getItem("isEmailVerified") === "true" ?
                                    <button
                                        // style={{ maxWidth: "70px" }}
                                        className="endverify verify bg-success text-light pe-3"
                                    >
                                        Verified
                                    </button>
                                    :
                                    <butoon className="endverify" onClick={() => {
                                        setOtp(["", "", "", "", "", ""]);
                                        sendOtp();
                                    }}>Verify</butoon>
                            }
                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            <Modal className="verifyemail" show={show1} onHide={handleClose1} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className="forarrow" onClick={() => {
                            handleClose1();
                            handleShow();
                        }}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                <path d="M15.2993 8.49998H2.70101M2.70101 8.49998L8.10028 3.10071M2.70101 8.49998L8.10028 13.8993" stroke="#222D37" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                            </svg></span>
                        Verify Email Address
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="maincontent">
                        <h3 className="mainheading"> We emailed you a six-digit code to <span>{email}</span> Enter the code below to confirm your email address</h3>
                        <div className="sixinputs">
                            {/* <input type="text" placeholder="" />
                            <input type="text" placeholder="" />
                            <input type="text" placeholder="" />
                            <input type="text" placeholder="" />
                            <input type="text" placeholder="" />
                            <input type="text" placeholder="" /> */}
                            {otp?.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-${index}`}
                                    type="text"
                                    value={digit}
                                    maxLength={1}
                                    onChange={(e) => handleOtpChange(e, index)}
                                    onKeyDown={(e) => handleOtpBackspace(e, index)}
                                />
                            ))}
                        </div>

                        <div className="endbtns">
                            <button className="cancle" onClick={handleClose1}>Cancel</button>
                            <butoon className="endverify" style={{ cursor: "pointer" }} onClick={() => {
                                // handleShow2();
                                // handleClose1();
                                setOtp(["", "", "", "", "", ""]);
                                verifyOtp();
                            }}>Verify</butoon>
                        </div>
                    </div>
                </Modal.Body>

            </Modal>
            <Modal className="verifyemail" show={show2} onHide={handleClose2} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="maincontent forcenter">
                        <div className="mainimages">
                            <img
                                src="\assets\dummy\tick.png"
                                alt="img"
                                className="img-fluid tick"
                            />
                        </div>
                        <p className="paramain">Email verified successfully</p>
                        <button className="ok" onClick={() => { handleClose2(); navigate('/notificationpreferences') }}>OK</button>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
};

export default NotificationPreferences;


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import "./notificationpreferences.scss";
// import { API_URL } from '../../utils/ApiUrl';

// const Notificationpreferences = () => {
//     const [preferences, setPreferences] = useState({ participateTasks: [], createTasks: [] });
//     console.log(preferences, 'preferences');

//     const participateTasks = [
//         { id: 1, name: "New Task Posted", description: "A new task is posted in a category you are interested in." },
//         { id: 2, name: "Submission Time Ending", description: "Submission time for a task you participated in is about to end." },
//         { id: 3, name: "Submission Under Review", description: "Your submission is under review by the task creator." },
//         { id: 4, name: "Winner Selected", description: "You were selected as the winner by the task creator." },
//         { id: 5, name: "Other Winner Selected", description: "Someone else was selected as the winner by the task creator." },
//         { id: 6, name: "Dispute Raised", description: "Dispute raised by another participant." },
//         { id: 7, name: "Dispute Win", description: "You were selected as the winner of the dispute." }
//     ];

//     const createTasks = [
//         { id: 8, name: "Participant Submitted Work", description: "A participant has submitted their work for the task you created." },
//         { id: 9, name: "Dispute Raised", description: "A dispute has been raised on a task you created." },
//         { id: 10, name: "Due Date Passed", description: "The due date for your task has passed." },
//         { id: 11, name: "Dispute Win", description: "You were selected as the winner of the dispute." }
//     ];

//     useEffect(() => {
//         const fetchPreferences = async () => {
//             const accessToken = localStorage.getItem("accessToken");
//             try {
//                 const response = await axios.get(`${API_URL}settings/preferences/notfication`, {
//                     headers: { Authorization: `Bearer ${accessToken}` }
//                 });
//                 const userPreferences = response.data.data.preferences;

//                 const updatedParticipateTasks = participateTasks.map(task => {
//                     const pref = userPreferences.find(p => p.description === task.description);
//                     return { ...task, viaWeb: pref ? pref.viaWeb : false, viaEmail: pref ? pref.viaEmail : false };
//                 });

//                 const updatedCreateTasks = createTasks.map(task => {
//                     const pref = userPreferences.find(p => p.description === task.description);
//                     return { ...task, viaWeb: pref ? pref.viaWeb : false, viaEmail: pref ? pref.viaEmail : false };
//                 });

//                 setPreferences({ participateTasks: updatedParticipateTasks, createTasks: updatedCreateTasks });
//             } catch (error) {
//                 console.error("Error fetching preferences:", error);
//             }
//         };

//         fetchPreferences();
//     }, []);

//     return (
//         <section className='mainpreferences'>
//             <img src="/assets/importantassets/backshade.png" alt="backshade" className="backshade" />
//             <div className='boxpreference'>
//                 <div className='upperperference'>
//                     <p>Notification Preferences</p>
//                     <button className='save'>Save</button>
//                 </div>
//                 <div className='participatetask'>
//                     <h2 className='upperheading'>When you participate in a task</h2>
//                     {preferences.participateTasks.map(task => (
//                         <div className='newtask' key={task.id}>
//                             <div className='left'>
//                                 <p>{task.description}</p>
//                             </div>
//                             <div className='right'>
//                                 <div className='parentcheck'>
//                                     <div className="checkboxmain">
//                                         <p className="checkboxpara">Website</p>
//                                         <label className="checkbox">
//                                             {task.viaWeb ? <img src="/assets/notification/checked.svg" alt="" srcset="" />
//                                             : <img src="/assets/notification/unchecked.svg" alt="" srcset="" />}
//                                         </label>
//                                     </div>
//                                     <div className="checkboxmain">
//                                         <p className="checkboxpara">Email</p>
//                                         <label className="checkbox">
//                                             {task.viaEmail ? <img src="/assets/notification/checked.svg" alt="" srcset="" />
//                                                 : <img src="/assets/notification/unchecked.svg" alt="" srcset="" />}
//                                         </label>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//                 <div className='participatetask'>
//                     <h2 className='upperheading'>When you create a task</h2>
//                     {preferences.createTasks.map(task => (
//                         <div className='newtask' key={task.id}>
//                             <div className='left'>
//                                 <p>{task.description}</p>
//                             </div>
//                             <div className='right'>
//                                 <div className='parentcheck'>
//                                     <div className="checkboxmain">
//                                         <p className="checkboxpara">Website</p>
//                                         <label className="checkbox">
//                                             {task.viaWeb ? <img src="/assets/notification/checked.svg" alt="" srcset="" />
//                                                 : <img src="/assets/notification/unchecked.svg" alt="" srcset="" />}
//                                         </label>
//                                     </div>
//                                     <div className="checkboxmain">
//                                         <p className="checkboxpara">Email</p>
//                                         <label className="checkbox">
//                                             {task.viaEmail ? <img src="/assets/notification/checked.svg" alt="" srcset="" />
//                                                 : <img src="/assets/notification/unchecked.svg" alt="" srcset="" />}
//                                         </label>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Notificationpreferences;

// import React from 'react';
// import "./notificationpreferences.scss";

// const participateTasks = [
//     "A new task is posted in a category you are interested in.",
//     "Submission time for a task you participated in is about to end.",
//     "Your submission is under review by the task creator.",
//     "You were selected as the winner by the task creator.",
//     "Someone else was selected as the winner by the task creator.",
//     "Dispute raised by another participant.",
//     "You were selected as the winner of the dispute."
// ];

// const createTasks = [
//     "A participant has submitted their work for the task you created.",
//     "A dispute has been raised on a task you created.",
//     "The due date for your task has passed.",
//     "You were selected as the winner of the dispute."
// ];

// const Notificationpreferences = () => {
//     return (
//         <>
//             <section className='mainpreferences'>
//                 <img src="/assets/importantassets/backshade.png" alt="backshade" className="backshade" />
//                 <div className='boxpreference'>
//                     <div className='upperperference'>
//                         <p>Notification Preferences</p>
//                         <button className='save'>Save</button>
//                     </div>

//                     <div className='participatetask'>
//                         <h2 className='upperheading'>When you participate in a task</h2>
//                         {participateTasks.map((task, index) => (
//                             <div className='newtask' key={index}>
//                                 <div className='left'>
//                                     <p>{task}</p>
//                                 </div>
//                                 <div className='right'>
//                                     <div className='parentcheck'>
//                                         {["Website", "Email"].map((type, idx) => (
//                                             <div className="checkboxmain" key={idx}>
//                                                 <p className="checkboxpara">{type}</p>
//                                                 <label className="checkbox">
//                                                     <input type="checkbox" />
//                                                     <span className="checkmark"></span>
//                                                 </label>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     <div className='participatetask'>
//                         <h2 className='upperheading'>When you create a task</h2>
//                         {createTasks.map((task, index) => (
//                             <div className='newtask' key={index}>
//                                 <div className='left'>
//                                     <p>{task}</p>
//                                 </div>
//                                 <div className='right'>
//                                     <div className='parentcheck'>
//                                         {["Website", "Email"].map((type, idx) => (
//                                             <div className="checkboxmain" key={idx}>
//                                                 <p className="checkboxpara">{type}</p>
//                                                 <label className="checkbox">
//                                                     <input type="checkbox" />
//                                                     <span className="checkmark"></span>
//                                                 </label>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default Notificationpreferences;
